import type { NetworkStatus } from "Hooks/useNetworkStatus";
import { getAppUrl, type Page } from "Utils/UrlUtils";

const PAGES_VISIBLE_WHILE_OFFLINE: Array<Page> = [];
const PAGES_VISIBLE_WHILE_SERVER_UNREACHABLE: Array<Page> = [];

const STATUS_TO_PAGES_MAP: Record<NetworkStatus, Array<Page>> = {
  online: [],
  offline: PAGES_VISIBLE_WHILE_OFFLINE,
  serverUnreachable: PAGES_VISIBLE_WHILE_SERVER_UNREACHABLE,
};

/**
 * Check if the overlay should be hidden for the current page and network status.
 *
 * @param networkStatus - Current network status
 * @param pathname - Current pathname
 * @returns true if overlay should be hidden, false otherwise
 */
export const shouldSuppressOverlay = (
  networkStatus: NetworkStatus,
  pathname: string,
) => {
  if (networkStatus === "online") {
    return true;
  }

  const appUrl = getAppUrl();
  const whitelist = STATUS_TO_PAGES_MAP[networkStatus];

  return whitelist.some((page) => pathname === appUrl(page));
};
